import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const MeasurmentSelector =
    (items) =>
    ({ addTab }) => {
        // TODO: FIX!!!
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [showMenu, setShowMenu] = useState(false);

        if (items.length === 0) {
            return null;
        }

        const optionList = items.map((o) => {
            return (
                <li key={`tab-option_${o.value}`}>
                    <button
                        className="button -text"
                        onClick={() => {
                            addTab(o);
                        }}
                    >
                        {o.text}
                    </button>
                </li>
            );
        });

        return (
            <div className="tab-selector">
                <button
                    className="button -primary -small"
                    onClick={() => {
                        setShowMenu(!showMenu);
                    }}
                >
                    <FontAwesomeIcon icon={faChevronDown} /> Add
                </button>
                {showMenu && (
                    <div className="dropdown">
                        <ul>{optionList}</ul>
                    </div>
                )}
            </div>
        );
    };

export default MeasurmentSelector;
